<template>
  <v-container>
    <MainText
      v-bind:mainHeader="text.mainHeader"
      v-bind:mainStory="text.mainStory"
      v-bind:mainUpdate="text.mainUpdate"
    />
    <LunchTables />

    <OtherTables />
  </v-container>
</template>

<script>
import MainText from "../components/mainText";
import LunchTables from "../components/lunchTables.vue";
import OtherTables from "../components/otherTables.vue";

export default {
  name: "Home",
  props: ["text"],
  components: { MainText, LunchTables, OtherTables },
};
</script>
